import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Faq, FaqCategory, FaqCategoryFaqResponse } from './_types';

export function normalizeFaqCategory(category: any): FaqCategory {
  return camelcaseKeys(category, { deep: true });
}

export function normalizeFaq(faq: any): Faq {
  return camelcaseKeys(faq, { deep: true });
}

export function normalizeFaqCategoriesResponse(response: any): FaqCategory[] {
  return (response || []).map(normalizeFaqCategory);
}

export function normalizeFaqsResponse(response: any): Faq[] {
  return (response || []).map(normalizeFaq);
}

export function normalizeFaqCategoryFaqResponse(
  response: any
): FaqCategoryFaqResponse {
  const camelized = camelcaseKeys(response, { deep: true });

  return {
    category: normalizeFaqCategory(camelized.category),
    faqs: (camelized.faqs || []).map(normalizeFaq),
  };
}
